import { createSelectorV8 } from "../../../utils/createSelector.js";
export const gridPreferencePanelStateSelector = state => state.preferencePanel;
export const gridPreferencePanelSelectorWithLabel = createSelectorV8(gridPreferencePanelStateSelector, (panel, labelId) => {
  if (panel.open && panel.labelId === labelId) {
    return true;
  }
  return false;
});